export default __webpack_public_path__ + "77eac4f899243142b4ee89a898ac3c49.png";